module.exports = __webpack_public_path__ + "img/advantage_01.4ad2fd6a.png";